import React, { useEffect, useState } from "react";
import styled from "styled-components";

import Spin from "antd/es/spin";

import useAuth from "hooks/useAuth";

import Routes from "./Routes";
import { FeatureToggleProvider } from "components/FeatureToggle";

async function checkAuthentication(auth) {
  await auth.actions.loggedInUser();
}

const App = () => {
  const [isReady, setIsReady] = useState(false);
  const auth = useAuth();

  // init app
  useEffect(() => {
    (async () => {
      await Promise.allSettled([checkAuthentication(auth)]).then(() => {
        setIsReady(true);
      });
    })();
    // eslint-disable-next-line
  }, []);

  if (!isReady) {
    return <AppLoadingFallback />;
  }

  return (
      <FeatureToggleProvider loadingFallback={<AppLoadingFallback />}>
        <Routes />
      </FeatureToggleProvider>
  );
};

const AppLoadingFallback = () => {
  return (
    <AppFallbackWrapper>
      <Spin />
    </AppFallbackWrapper>
  );
};

const AppFallbackWrapper = styled.div`
  height: 100vh;
  background-color: #fafbfc;

  display: flex;
  flex-direction: column;
  justify-content: center;

  & .ant-spin .ant-spin-dot {
    font-size: 24px;
  }
`;

export default App;
